import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { SpendingAccountsContainer, Container, Content } from '@simplybenefits/sb-ui-library';
import SubmitClaim from '../Claims/SubmitClaim/index.js';
import { setCurrentSidebarItem } from '../../actions/user.js';
import { getLsaItems } from '../../actions/spendingAccounts.js';
import { navigateTo } from '../../services/helpers.js';

/**
 * @param {*} param0 
 * @returns 
 */
const SpendingAccounts = ({ 
    meta, 
    history, 
    dispatch, 
    lifestyleItems, 
    healthItems, 
    coverage, 
    spendingAccountData,
    dependents,
    hsaClaimTypes,
    lsaClaimTypes,
    whitelabel
}) => {
    const [ submitLifestyleClaimDialogOpen, setSubmitLifestyleClaimDialogOpen ] = useState(false);
    const [ submitHealthClaimDialogOpen, setSubmitHealthClaimDialogOpen ] = useState(false);

    useEffect(() => {
        if (meta?.isDependent && meta?.isSpendingAccountOnly === 1) {
            navigateTo('/not-found');
        }

        dispatch(setCurrentSidebarItem('spending-accounts'));
    }, []);

    return (
        <Container customStyle={{ width: '94%' }}>
            <Content>
                <SpendingAccountsContainer
                    meta={meta}
                    addBanking={() => history.push('/my-account')}
                    submitLifestyleClaim={() => setSubmitLifestyleClaimDialogOpen(true) }
                    submitHealthClaim={() => setSubmitHealthClaimDialogOpen(true) }
                    lifestyleItems={lifestyleItems}
                    healthItems={healthItems}
                    getLsaItems={ () => dispatch(getLsaItems()) }
                    coverage={coverage.spendingAccounts}
                    maximums={spendingAccountData}
                    dependents={dependents}
                    hsaClaimTypes={hsaClaimTypes}
                    lsaClaimTypes={lsaClaimTypes}
                    whitelabel={whitelabel}
                />
                {
                    submitLifestyleClaimDialogOpen &&
                        <SubmitClaim
                            close={() => setSubmitLifestyleClaimDialogOpen(false)}
                            type="Lifestyle"
                        />
                }
                {
                    submitHealthClaimDialogOpen &&
                        <SubmitClaim
                            close={() => setSubmitHealthClaimDialogOpen(false)}
                            type="HealthSpending"
                        />
                }
            </Content>
        </Container>
    );
};

SpendingAccounts.propTypes = {
    loading: PropTypes.bool,
    healthItems: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array
    ]),
    healthTotal: PropTypes.number,
    healthRemaining: PropTypes.number,
    lifestyleItems: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array
    ]),
    lifestyleTotal: PropTypes.number,
    lifestyleRemaining: PropTypes.number,
    whitelabel: PropTypes.object,
    meta: PropTypes.object
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    loading: state.spendingAccounts.loading,
    coverage: state.coverage.data,
    hsaClaimTypes: state.usage.data.claimTypes,
    healthItems: state.spendingAccounts.health.items,
    healthTotal: state.spendingAccounts.health.total,
    healthRemaining: state.spendingAccounts.health.remaining,
    healthRollover: state.spendingAccounts.health.rollover,
    lifestyleItems: state.spendingAccounts.lifestyle.items,
    lsaClaimTypes: state.spendingAccounts.lsaClaimTypes,
    lifestyleTotal: state.spendingAccounts.lifestyle.total,
    lifestyleRemaining: state.spendingAccounts.lifestyle.remaining,
    lifestyleRollover: state.spendingAccounts.lifestyle.rollover,
    whitelabel: state.whitelabel,
    meta: state.user.meta,
    dependents: state.user.dependents,
    spendingAccountData: state.spendingAccounts
});

export default connect(mapStateToProps)(SpendingAccounts);